import { render } from "./HeroFooterHeader.vue?vue&type=template&id=582f88b5"
import script from "./HeroFooterHeader.vue?vue&type=script&lang=js"
export * from "./HeroFooterHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__